import * as THREE from 'three';

type Direction = 'SE' | 'SW' | 'NE' | 'NW' | 'ES' | 'EN' | 'WN' | 'WS';

export function LineCurved(
    scene: THREE.Scene,
    x1: number,
    z1: number,
    radius: number,
    direction: Direction,
    thickness: number = 0.1
): void {
    const y: number = -0.001; // Position sur Y (évite le Z-fighting)
    let start = new THREE.Vector3(x1, y, z1);
    let control: THREE.Vector3, end: THREE.Vector3;

    // Configuration des points en fonction de la direction
    switch (direction) {
        case 'SW':
            control = new THREE.Vector3(x1, y, z1 + radius);
            end = new THREE.Vector3(x1 + radius, y, z1 + radius);
            break;
        case 'WS':
            control = new THREE.Vector3(x1 + radius, y, z1);
            end = new THREE.Vector3(x1 + radius, y, z1 + radius);
            break;
        case 'WN':
            control = new THREE.Vector3(x1 - radius, y, z1);
            end = new THREE.Vector3(x1 - radius, y, z1 - radius);
            break;
        case 'NE':
            control = new THREE.Vector3(x1, y, z1 - radius);
            end = new THREE.Vector3(x1 - radius, y, z1 - radius);
            break;
        case 'SE':
            control = new THREE.Vector3(x1, y, z1 + radius);
            end = new THREE.Vector3(x1 - radius, y, z1 + radius);
            break;
        case 'ES':
            control = new THREE.Vector3(x1 - radius, y, z1);
            end = new THREE.Vector3(x1 - radius, y, z1 + radius);
            break;
        case 'NW':
            control = new THREE.Vector3(x1, y, z1 - radius);
            end = new THREE.Vector3(x1 + radius, y, z1 - radius);
            break;
        case 'EN':
            control = new THREE.Vector3(x1 + radius, y, z1);
            end = new THREE.Vector3(x1 + radius, y, z1 - radius);
            break;
        default:
            console.error('Direction invalide. Utilisez SE, SW, NW, NE, ES, EN, WS, WN.');
            return;
    }

    // Crée la courbe Bézier
    const curve = new THREE.QuadraticBezierCurve3(start, control, end);

    // Générer un tube aplati pour une bande courbée
    const tubeGeometry = new THREE.TubeGeometry(curve, 64, thickness / 2, 8, false);
    tubeGeometry.scale(1, 0, 1); // Aplati la géométrie

    // Matériau
    const material = new THREE.MeshBasicMaterial({ color: 0xCFC4F7, side: THREE.DoubleSide });

    // Création de la bande courbée
    const curvedLine = new THREE.Mesh(tubeGeometry, material);

    scene.add(curvedLine);
}
